import React from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import AppRouter from './routes';
import { HelmetProvider } from 'react-helmet-async';
import Sidebar from './components/Sidebar';
import { TitleProvider } from './routes/TitleContext';

const Layout = () => {
  const location = useLocation();
  // Signed in? Read on every navigation, which is when it can change: logging in navigates, and
  // so does Logout. A role that does not parse is nobody.
  const isSignedIn = Number.isInteger(parseInt(localStorage.getItem('userRole'), 10));
  // No menu on the login page, none on a report -- those open in their own tab to be printed --
  // and none for somebody who is not signed in. HelmetWrapper is already sending that person to
  // /login; this is so they do not see the app's own chrome on the way, which is what "showing
  // the dashboard with Profile, Change Password and Logout" was.
  const isMasterReport = location.pathname.startsWith('/reports') || location.pathname.startsWith('/login') || !isSignedIn;
  return (
    <div>
      {!isMasterReport && <Sidebar />}
      {/* The menu is only reserved room where it is actually docked open. On a phone -- upright
          or held sideways -- it is a drawer over the page, so the page keeps the full width. */}
      <main className={`p-4 ${!isMasterReport ? 'desk:ml-64' : ''}`}>
        <AppRouter />
      </main>
    </div>
  );
};

function App() {
 
  return (
    <HelmetProvider>
    <Router>
      <TitleProvider>
        <Layout />
      </TitleProvider>
    </Router>
    </HelmetProvider>
  );
}

export default App;
